var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-padding": "" } },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c("app-client-portal-general-settings", {
                attrs: { config: _vm.config },
                on: { save: _vm.save },
              }),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("app-client-portal-payment-qr-settings", {
                        attrs: { settings: _vm.config.PaymentQrCodeSettings },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("app-client-portal-email-template-settings", {
                        attrs: { grow: _vm.$wf.isMdUp },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }